import { css } from 'react-emotion';

export const ScrollBarCSS = (thumbColor: string) => css`
  &::-webkit-scrollbar {
    width: 24px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0 12px 12px 0;
    background-color: #444;
    box-shadow: 0 0 0 2px black;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background-color: ${thumbColor};
    box-shadow: 0 0 0 2px black;
    width: 24px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ScrollBarCSS.ts